import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import LogoWhite from "../../assets/img/mainLogoLight.svg";

const useStyles = makeStyles((theme) => ({
  mainLogo: {
    "&:hover": {
      cursor: "pointer",
    },
    width: "100%",
    minWidth: "150px",
    maxWidth: "160px",
  },
}));

export default function LandingPageNavbar(props) {
  const classes = useStyles();
  const history = useHistory();
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 50;

      setScroll(scrollCheck);
    });
  });

  return (
    <div
      className={`fixed flex justify-between px-3 py-1 items-center w-full transition-all  ${
        scroll && "navbar-scrolled"
      }`}
      style={{ zIndex: "99" }}
    >
      <div
        className="flex items-center -ml-3 md:-ml-0"
        onClick={() => {
          history.push(`/`);
        }}
      >
        <img
          src={LogoWhite}
          className={classes.mainLogo}
          alt="PocketBits"
        ></img>
      </div>
      <div className="flex items-center ">
        {" "}
        <div
          className="bg-[#303030] mr-3 py-2 md:px-8 px-4 rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer"
          onClick={() => {
            history.push("/trade/BTC");
          }}
        >
          TRADE
        </div>
        <div
          className="hidden md:block bg-[#303030] mr-3  md:px-8 py-2 px-4  rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer"
          onClick={() => {
            history.push("/createacc");
          }}
        >
          CREATE AN ACCOUNT
        </div>
        <div
          className="bg-pb-primary-100  md:px-8 py-2 px-4 rounded-lg text-white w-max font-bold hover:bg-opacity-50 transition-all cursor-pointer"
          onClick={() => {
            history.push("/login");
          }}
        >
          SIGN IN
        </div>
      </div>
      <style>
        {`
          .navbar-scrolled{
               background-color: rgba(0,0, 0, 0.01);
  backdrop-filter: blur(20px) saturate(160%) contrast(45%) brightness(100%);
  -webkit-backdrop-filter: blur(20px) saturate(160%) contrast(45%) brightness(140%);

          }`}
      </style>
    </div>
  );
}
